<template>
  <div>
    <h1>New Cookie</h1>

    <div v-if="loading" class="alert alert-info" role="status">Loading...</div>
    <div v-if="error" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span> {{ error }}</div>

    <CookieForm :handle-submit="create" :values="item" :errors="violations"></CookieForm>

    <footer class="footer fixed-bottom bn-footer">
      <div style="float:right">
        <router-link :to="{ name: 'CookieList' }" class="btn btn-primary btn-sm">Back to list</router-link>
      </div>
    </footer>
  </div>
</template>

<script>
  import CookieForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('cookie/create');

  export default {
    components: {
      CookieForm
    },
    data: function() {
      return {
        item: {}
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
          item.duration=parseInt(item.duration);

        this.$store.dispatch('cookie/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'CookieUpdate', params: { id: created['@id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cookie/Create.vue